var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadWithoutPadding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_452_37595)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.3962 11.1605L18.8362 9.62703L12.6057 15.7433V0H10.3942V15.7433L4.16382 9.62703L2.6038 11.1605L11.5 19.9051L20.3962 11.1605Z",
    fill: "#214ba5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7885 18.4683V21.8262H3.21147V18.4683H1V22.0736C1 22.5845 1.20646 23.0745 1.57399 23.4357C1.94152 23.797 2.44 24 2.95976 24H20.0402C20.5601 24 21.0585 23.797 21.426 23.4357C21.7935 23.0745 22 22.5845 22 22.0736V18.4683H19.7885Z",
    fill: "#214ba5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3962 11.1605L18.8362 9.62703L12.6057 15.7433V0H10.3942V15.7433L4.16382 9.62703L2.6038 11.1605L11.5 19.9051L20.3962 11.1605Z",
    stroke: "#214ba5",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7885 18.4683V21.8262H3.21147V18.4683H1V22.0736C1 22.5845 1.20646 23.0745 1.57399 23.4357C1.94152 23.797 2.44 24 2.95976 24H20.0402C20.5601 24 21.0585 23.797 21.426 23.4357C21.7935 23.0745 22 22.5845 22 22.0736V18.4683H19.7885Z",
    stroke: "#214ba5",
    strokeWidth: 0.35
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_452_37595"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadWithoutPadding);
export default __webpack_public_path__ + "static/media/download-without-padding.3921a3f2f574d923d53fce1a1861043a.svg";
export { ForwardRef as ReactComponent };